import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import {
  API_CONFIG,
  BaseCrudService,
  buildSearchByTerm,
  PageResponse,
} from '@nebula-shared/data-access';

import { ApiResponse } from '@nebula-shared/domain';

import { CountryModal } from '../../domain/paises-modal.model';

@Injectable({ providedIn: 'root' })
export class CountryService extends BaseCrudService<CountryModal> {
  constructor() {
    super();
    const config = API_CONFIG.masters;
    this.setBaseUrl(`${config.baseUrl}${config.endpoints.paises}`);
  }

  getAllCity(
    page: number,
    size: number,
    departamentoCodigo: string,
    searchTerm?: string,

    sortColumn?: string,
    sortDirection: 'ASC' | 'DESC' = 'ASC',
  ): Observable<PageResponse<CountryModal>> {
    const searchsBy = [
      {
        key: 'estadoCiudad',
        operation: 'MATCH',
        value: 'ACTIVO',
        linkOperator: 'AND',
      },
      {
        key: 'departamentoCodigo',
        operation: 'MATCH',
        value: departamentoCodigo,
        linkOperator: 'AND',
      },
      ...buildSearchByTerm(searchTerm, [
        { key: 'codigo', type: 'text' },
        { key: 'nombre', type: 'text' },
      ]),
    ];

    const ordersBy: { column: string; direction: 'ASC' | 'DESC' }[] = [];
    if (sortColumn) {
      ordersBy.push({ column: sortColumn, direction: sortDirection });
    }

    const body = {
      page: page.toString(),
      size: size.toString(),
      ...(searchsBy.length > 0 && { searchsBy }),
      ...(ordersBy.length > 0 && { ordersBy }),
    };

    return this.getPageResponseRaw(page, size, body).pipe(
      map((response: ApiResponse<PageResponse<CountryModal>>) => {
        const envelope = response?.response || response;
        const pageData = envelope?.content || envelope || {};

        return {
          size: pageData.size || size,
          number: pageData.number || page,
          numberOfElements: pageData.numberOfElements || pageData.content?.length || 0,
          totalElements: pageData.totalElements || 0,
          totalPages: pageData.totalPages || 0,
          content: pageData.content || [],
          empty: !pageData.content || pageData.content.length === 0,
        };
      }),
    );
  }
}
